function Header(){
    return (
        <div className="header">
            <h1>Rick and Morty: Characters</h1>
        </div>
    )
}

export default Header;